<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="notice__page" style="height: 0;">
          <div class="notice__page__li type_04">
            <div class="txt">
              <p>{{ noticeDetail.boardTitle }}</p>
              <p class="date">{{ $moment(noticeDetail.regDate).format('YYYY.MM.DD') }}</p>
            </div>
          </div>
          <div class="txt__inner editor"  v-html="noticeDetail.boardDescription" style="padding-bottom: 3rem;">
<!--            <p>목숨이 긴지라 천하를 소리다.이것은 듣기만 몸이 인도하겠다는 보는 반짝이는 것이다. 우리 커다란 예가 있으며, 용감하고 것이다. 싸인 더운지라 얼음과 몸이 끓는 그림자는 속에 것이다. 품에 청춘 과실이 심장의 봄바람이다. 설레는 심장의 내는 때에, 열락의 풀이 사람은 힘있다. 열락의 방지하는 가지에 공자는 많이 인생의 듣는다. 고동을 바로 우리의 눈이 그들에게 보이는 것이 창공에 말이다. 위하여, 무엇이 주며, 사막이다. 위하여서 그들에게 원대하고, 청춘의 않는 그들에게 불러 약동하다. 위하여 청춘이 이상 가지에 것이다.</p>-->
<!--            <img src="static/images/img_328x120.png" alt="">-->
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      isShow: false,
      params: {
        boardNo: this.$route.query.boardNo
      },
      noticeDetail: {}
    }
  },
  created: function () {
    this.getNoticeDetail()
  },
  methods: {
    getNoticeDetail: async function () {
      this.$MypageSvc.getBoardDetail(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
          if (code === 1) {
            this.isShow = true
            this.noticeDetail = entity
          }
        })
    }
  }
}
</script>
